import {
  useTranslation
} from "../chunk-6N4NEKWU.mjs";
import "../chunk-D57E6H3M.mjs";

// src/i18n/useComponentsTranslation.ts
import { componentsI18n } from "./instance.mjs";
function useComponentsTranslation() {
  return useTranslation(void 0, { i18n: componentsI18n });
}
export {
  useComponentsTranslation
};
//# sourceMappingURL=useComponentsTranslation.mjs.map